var React = require('react');

function Tiktok (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.6891 3.68473L15.2548 3H12.6268V9.16708L12.6178 15.1909C12.6223 15.2357 12.6268 15.2849 12.6268 15.3297C12.6268 16.8379 11.4001 18.0686 9.88681 18.0686C8.37356 18.0686 7.14684 16.8424 7.14684 15.3297C7.14684 13.8215 8.37356 12.5908 9.88681 12.5908C10.2002 12.5908 10.5047 12.6489 10.7867 12.7474V9.73993C10.4957 9.6907 10.1957 9.66385 9.88681 9.66385C6.76628 9.66832 4.2233 12.2103 4.2233 15.3342C4.2233 18.458 6.76628 21 9.89129 21C13.0163 21 15.5593 18.458 15.5593 15.3342V8.16907C16.692 9.30134 18.156 10.4068 19.7767 10.7603V7.68573C18.0172 6.90701 16.2667 4.60666 15.6891 3.68473Z","fill":"black"}));
}

Tiktok.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Tiktok;

Tiktok.default = Tiktok;
